import React from 'react';
import Spacing from '../Spacing';
import SectionHeadingStyle3 from '../SectionHeading/SectionHeadingStyle3';
import { pageTitle } from '../../helpers/PageTitle';
import { ImageConstants } from '../../assets/ImageConstants';
import './ContactPage.css';

export default function GroupPadelCoachingEmbedded() {
  pageTitle('Group Padel Coaching - Embedded Form');

  return (
    <>
      <style>
        {`
        .cs_contact_form_wrap {
    max-height: 868px;
        }
         .cs_fs_50 {
    font-size: 39px;}
        .cs_contact_form_wrap {
    position: relative;
    padding: 90px 0 85px 0px;
}

.cs_breadcrumb_section {
  position: relative;
  height: 300px;
  background-image: url(${ImageConstants.videoBanner});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  text-align: center;
}

.cs_breadcrumb_section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1;
}

.cs_breadcrumb_content {
  position: relative;
  z-index: 2;
}
  .RVEQke {
    background-color: rgb(0 243 255);!important}

.cs_breadcrumb_title {
  font-size: 48px;
  font-weight: 700;
  margin-bottom: 10px;
  text-transform: uppercase;
}

.cs_breadcrumb_subtitle {
  font-size: 18px;
  opacity: 0.9;
}

.cs_embedded_form_container {
  background: #fff;
  border-radius: 15px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  margin: 20px 0;
}

.cs_embedded_form_wrapper {
  position: relative;
  width: 100%;
  height: 600px;
  border: none;
  border-radius: 15px;
}

.cs_form_header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 30px;
  text-align: center;
  border-radius: 15px 15px 0 0;
}

.cs_form_header h3 {
  margin: 0;
  font-size: 24px;
  font-weight: 600;
}

.cs_form_header p {
  margin: 10px 0 0 0;
  opacity: 0.9;
  font-size: 16px;
}

@media (max-width: 768px) {
.cs_dark .cs_moving_text_wrap.cs_style_1 {
    margin-top: 95px!important;}
  .cs_breadcrumb_section {
    height: 200px;
  }
  .cs_breadcrumb_title {
    font-size: 32px;
  }
  .cs_breadcrumb_subtitle {
    font-size: 16px;
  }
  .cs_embedded_form_wrapper {
    height: 700px;
  }
}
        `
        }
        
      </style>
      
      {/* Breadcrumb Section */}
      <section className="cs_breadcrumb_section">
        <div className="cs_breadcrumb_content">
          {/* <h1 className="cs_breadcrumb_title">Group Padel Coaching</h1> */}
          {/* <p className="cs_breadcrumb_subtitle">Registration Form</p> */}
        </div>
      </section>
      
      {/* <Spacing lg="140" md="80" /> */}
      {/* <Spacing lg="75" md="60" /> */}
      <section>
        <div className="container">
          <div className="row align-items-center cs_gap_y_45">
            <div className="col-lg-6">
            {/* <Spacing lg="75" md="60" /> */}
            <Spacing lg="75" md="60" />
              <SectionHeadingStyle3
                title=""
                subTitle="Group Padel Coaching"
                shape=""
              /> 
              <h2 className="cs_fs_50">
                Register Now Group <br />
                 Padel Coaching Sessions 
              </h2>
              {/* <div className="cs_height_55 cs_height_lg_30" />
              <div className="cs_height_55 cs_height_lg_30" /> */}
              <div className="cs_gray_bg_3 p-4 rounded">
                <p className="cs_fs_21 mb-3">
                  Now enrolling Kids, Gents, and Ladies for our exciting new training sessions!
                  {/* <strong>Join our professional coaching program.</strong> */}
                </p>
                <ul className="cs_mp0 cs_contact_info">
                  <li>
                    <h3 className="cs_fs_29 cs_semibold">Starting Date:</h3>
                    <p className="mb-0">July 21st</p>
                  </li>
                  <li>
                    <h3 className="cs_fs_29 cs_semibold">Training Days:</h3>
                    <p className="mb-0">Monday, Wednesday & Thursday</p>
                  </li>
                  <li>
                    <h3 className="cs_fs_29 cs_semibold">Schedule:</h3>
                    <p className="mb-0">10 hourly sessions per month</p>
                  </li>
                  <li>
                    <h3 className="cs_fs_29 cs_semibold">Monthly Fee:</h3>
                    <p className="mb-0">PKR 20,000</p>
                  </li>
                </ul>
                {/* <p className="mt-3">
                  Whether you're just starting out or looking to improve your game, our professional coaches are here to help you level up in a fun, supportive environment. Limited slots available. Register now and get ready to play!
                </p> */}
                {/* <div className="alert alert-info mt-3">
                  <strong>Note:</strong> This form is powered by Google Forms for secure data collection.
                </div> */}
              </div>
            </div>
            <div className="col-lg-6">
              <div className="cs_contact_form_wrap">
                <div className="cs_gray_bg_3 " />
                <div className="cs_embedded_form_container">
                  <div className="cs_form_header">
                    <h3 className='text-white'>Group Padel Coaching Registration</h3>
                    <p>Complete the form below to join our training sessions</p>
                  </div>
                  <iframe
                    src="https://docs.google.com/forms/d/e/1FAIpQLSeTTGgw4BVomMwq0hgtfeOFZMFFYD6goI_Ju5rJ8sBLBzL8hA/viewform?embedded=true"
                    className="cs_embedded_form_wrapper"
                    frameBorder="0"
                    marginHeight="0"
                    marginWidth="0"
                    title="Group Padel Coaching Registration Form"
                  >
                    Loading…
                  </iframe>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div className="cs_height_120 cs_height_lg_80" />
    </>
  );
} 